<template>
  <div class="document-creator-container py-4 px-2">
    <!-- Overlay de carga estilizado -->
    <v-overlay v-if="loading" opacity="0.75" color="white" light>
      <div class="text-center">
        <v-progress-circular indeterminate size="64" color="primary" class="mb-4" width="4"></v-progress-circular>
        <div class="text-subtitle-1 font-weight-bold grey--text text--darken-3">Cargando Documento...</div>
      </div>
    </v-overlay>

    <!-- Encabezado -->
    <div class="d-flex flex-wrap align-center justify-space-between mb-4 pb-3 border-bottom">
      <div>
        <div class="d-flex align-center flex-wrap">
          <h2 class="text-h5 font-weight-bold text-slate-800 mr-3 mb-0">Conteo Rápido de Stocks</h2>

        </div>
        <p class="text-body-2 grey--text text--darken-1 mt-1 mb-0">
          Siga los pasos para realizar el ajuste de stock del inventario.
        </p>
      </div>

      <!-- Botón Regresar al documento -->

    </div>

    <!-- Stepper -->
    <v-stepper v-model="currentStep" class="stepper-custom rounded-xl elevation-0" alt-labels>
      <!-- Stepper Header -->
      <v-stepper-header class="stepper-header-custom elevation-0">
        <v-stepper-step :complete="currentStep > 1" step="1" color="primary" class="stepper-step-custom">
          <span class="stepper-label">Departamento<br>y Almacén</span>
        </v-stepper-step>
        <v-divider class="stepper-divider"></v-divider>
        <v-stepper-step :complete="currentStep > 2" step="2" color="primary" class="stepper-step-custom">
          <span class="stepper-label">Conteo de<br>Mercancías</span>
        </v-stepper-step>
        <v-divider class="stepper-divider"></v-divider>
        <v-stepper-step :complete="currentStep > 3" step="3" color="amber darken-3" class="stepper-step-custom">
          <span class="stepper-label">Confirmación<br>y Aplicar</span>
        </v-stepper-step>
      </v-stepper-header>

      <v-stepper-items>
        <!-- ═══════════════════════════════════════════════════ -->
        <!--  PASO 1: Selección de Departamento y Almacén        -->
        <!-- ═══════════════════════════════════════════════════ -->
        <v-stepper-content step="1" class="pa-4">
          <v-card outlined class="rounded-xl pa-6 step-card">
            <div class="d-flex align-center mb-6">
              <v-avatar color="primary lighten-5" size="44" class="rounded-xl mr-3">
                <v-icon color="primary" size="24">mdi-store-outline</v-icon>
              </v-avatar>
              <div>
                <div class="text-subtitle-1 font-weight-bold text-slate-800">Configuración del Conteo</div>
                <div class="text-caption grey--text text--darken-1">Seleccione el departamento y almacén para el conteo
                  de inventario</div>
              </div>
            </div>

            <v-row>
              <v-col cols="12" md="6">
                <div class="field-label mb-1">
                  <span class="text-caption font-weight-bold text-slate-700 text-uppercase">Departamento</span>
                </div>
                <v-autocomplete :items="modulos" label="Departamento" outlined dense rounded hide-details="auto"
                  class="custom-input" @input="

                    $forceUpdate();
                  " v-model="Departamento"></v-autocomplete>
              </v-col>

              <v-col cols="12" md="6">
                <div class="field-label mb-1">

                  <span class="text-caption font-weight-bold text-slate-700 text-uppercase">Almacén (Centro de
                    Consumo)</span>
                </div>
                <v-autocomplete v-model="Origen" :items="origenes" item-text="Nombre" item-value="id"
                  placeholder="Seleccione un almacén..." outlined dense rounded hide-details="auto" class="custom-input"
                  :disabled="Estatus == 'A'" no-data-text="No se encontraron almacenes">
                  <template v-slot:item="{ item }">

                    <v-list-item-content>
                      <v-list-item-title class="text-body-2 font-weight-medium">{{ item.Nombre }}</v-list-item-title>
                      <v-list-item-subtitle class="text-caption grey--text">{{ item.Origen }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>

            <!-- Info summary cuando ya hay datos cargados -->
            <v-alert v-if="OrnData && OrnData.id" outlined color="info" dense class="mt-4 rounded-lg"
              icon="mdi-information-outline">
              <span class="text-caption">
                Documento: <strong>{{ OrnData.id }}</strong> —
                Los productos del conteo se cargarán automáticamente.
              </span>
            </v-alert>

            <!-- Acciones Paso 1 -->
            <div class="d-flex justify-end mt-6">
              <v-btn color="primary" depressed class="font-weight-bold rounded-lg action-btn" :disabled="!Origen"
                @click="goToStep2">
                Continuar al Conteo
                <v-icon right size="18">mdi-arrow-right</v-icon>
              </v-btn>
            </div>
          </v-card>
        </v-stepper-content>

        <!-- ═══════════════════════════════════════════════════ -->
        <!--  PASO 2: Conteo de Mercancías                       -->
        <!-- ═══════════════════════════════════════════════════ -->
        <v-stepper-content step="2" class="pa-4">
          <!-- Formulario para agregar producto existente -->

          <!-- Layout principal del conteo -->
          <v-row class="ma-0 mt-2">
            <!-- Selector y Lista de Conteo (Izquierda) -->
            <v-col cols="12" md="8" lg="8" class="pa-2">
              <v-card outlined class="product-picker-card rounded-xl pa-4">
                <addProductForm :Origen="Origen" :defaultOption="1" :key="formExistKey" @successData="saveExistProduct">
                </addProductForm>
              </v-card>

            </v-col>
            <v-col cols="12" md="4" lg="4" class="pa-2">
              <v-card outlined class="product-picker-card rounded-xl pa-4">
                <div class="picker-header mb-4">
                  <div class="d-flex align-center mb-2">
                    <v-icon color="cyan darken-2" class="mr-2" size="22">mdi-package-variant</v-icon>
                    <span class="text-subtitle-1 font-weight-bold text-slate-800">Productos a Contar</span>
                  </div>
                  <v-chip class="font-weight-bold" color="grey lighten-4" text-color="slate-800" small>
                    Total: {{ productosCount.length }} items
                  </v-chip>
                </div>

                <v-text-field v-model="filterProduct" label="Filtrar producto en documento..." outlined dense rounded
                  hide-details class="custom-input mb-3" prepend-inner-icon="mdi-magnify" clearable></v-text-field>

                <v-divider class="mb-2"></v-divider>

                <v-list class="product-list-scroll rounded-lg py-0 overflow-y-auto" style="max-height: 54vh" flat>
                  <template v-for="(item, index) in productosCount">
                    <v-list-item :key="item.id || item.nm" class="product-list-item my-2 rounded-lg px-3 py-2">
                      <v-list-item-avatar tile size="40" class="rounded-lg grey lighten-4 mr-3">
                        <v-icon color="cyan darken-2" size="24">mdi-package-variant-closed</v-icon>
                      </v-list-item-avatar>

                      <v-list-item-content class="pa-0">
                        <v-list-item-title class="text-body-2 font-weight-bold text-slate-800 mb-1"
                          v-html="item.nm"></v-list-item-title>

                        <v-row class="ma-0 align-center justify-space-between mt-1">
                          <v-col cols="6" class="pa-0 text-caption grey--text text--darken-2">
                            <div>Existencia: <span class="font-weight-bold text-slate-800">{{
                              $pgsHelper.formatNumber(getExistencia(item.id).Existencia) }}</span></div>
                            <div class="text-uppercase font-weight-semibold text-slate-600 mt-0.5">{{
                              getExistencia(item.id).Unidad }}</div>
                          </v-col>

                          <v-col cols="6" class="pa-0 d-flex justify-end">
                            <div class="spinner-container d-flex align-center rounded-lg border-light px-1 bg-slate-50">
                              <v-btn icon x-small color="red" @click="item.cn--" :disabled="Estatus == 'A'"
                                class="spinner-btn">
                                <v-icon size="14">mdi-minus</v-icon>
                              </v-btn>
                              <v-text-field v-model="item.cn" type="number" dense flat solo hide-details
                                background-color="transparent"
                                class="spinner-input text-center text-body-2 font-weight-bold ma-0 pa-0"
                                :disabled="Estatus == 'A'"></v-text-field>
                              <v-btn icon x-small color="green" @click="item.cn++" :disabled="Estatus == 'A'"
                                class="spinner-btn">
                                <v-icon size="14">mdi-plus</v-icon>
                              </v-btn>
                            </div>
                          </v-col>
                        </v-row>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider v-if="index < productosCount.length - 1" :key="'div-' + index"
                      class="my-1 mx-3"></v-divider>
                  </template>
                  <div v-if="productosCount.length === 0" class="text-center py-8 px-4 grey--text text--lighten-1">
                    <v-icon size="36" color="grey lighten-2" class="mb-2">mdi-package-variant</v-icon>
                    <div class="text-caption">No se encontraron productos</div>
                  </div>
                </v-list>
              </v-card>
            </v-col>


          </v-row>

          <!-- Acciones Paso 2 -->
          <div class="d-flex justify-space-between mt-4">
            <v-btn text class="font-weight-bold rounded-lg action-btn text-slate-700" @click="currentStep = 1">
              <v-icon left size="18">mdi-arrow-left</v-icon>
              Anterior
            </v-btn>

            <div class="d-flex gap-2">


              <v-btn color="amber darken-3" dark depressed class="font-weight-bold rounded-lg action-btn"
                @click="goToStep3">
                Revisar y Aplicar
                <v-icon right size="18">mdi-arrow-right</v-icon>
              </v-btn>
            </div>
          </div>
        </v-stepper-content>

        <!-- ═══════════════════════════════════════════════════ -->
        <!--  PASO 3: Confirmación para Aplicar a Inventarios    -->
        <!-- ═══════════════════════════════════════════════════ -->
        <v-stepper-content step="3" class="pa-4">
          <v-card outlined class="rounded-xl pa-6 step-card">
            <div class="d-flex align-center mb-6">

              <div>
                <div class="text-subtitle-1 font-weight-bold text-slate-800">Confirmación Final</div>
                <div class="text-caption grey--text text--darken-1">Revise el resumen del conteo antes de aplicar al
                  inventario
                </div>
              </div>
            </div>

            <!-- Resumen de configuración -->
            <v-row class="mb-4">
              <v-col cols="12" sm="6">
                <v-card outlined class="rounded-xl pa-4 summary-info-card">
                  <div class="text-caption font-weight-bold text-uppercase grey--text text--darken-1 mb-2">
                    <v-icon size="14" class="mr-1">mdi-office-building-outline</v-icon>Departamento
                  </div>
                  <div class="text-subtitle-1 font-weight-bold text-slate-800">
                    {{ Departamento || '—' }}
                  </div>
                </v-card>
              </v-col>
              <v-col cols="12" sm="6">
                <v-card outlined class="rounded-xl pa-4 summary-info-card">
                  <div class="text-caption font-weight-bold text-uppercase grey--text text--darken-1 mb-2">
                    Almacén
                  </div>
                  <div class="text-subtitle-1 font-weight-bold text-slate-800">
                    {{ getNombreAlmacen(Origen) || '—' }}
                  </div>
                </v-card>
              </v-col>
            </v-row>

            <!-- KPIs de resumen -->
            <v-row v-if="false" class="mb-4">
              <v-col cols="12" sm="4">
                <v-card outlined class="rounded-xl pa-4 kpi-confirm-card total-kpi">
                  <div class="d-flex align-center justify-space-between">
                    <div>
                      <div class="text-caption grey--text font-weight-medium mb-1">Total Productos</div>
                      <div class="text-h4 font-weight-bold text-slate-800">{{ productsDocument.length }}</div>
                    </div>
                    <v-avatar color="blue lighten-5" size="44" class="rounded-xl">
                      <v-icon color="blue darken-3">mdi-package-variant</v-icon>
                    </v-avatar>
                  </div>
                </v-card>
              </v-col>
              <v-col cols="12" sm="4">
                <v-card outlined class="rounded-xl pa-4 kpi-confirm-card diff-kpi">
                  <div class="d-flex align-center justify-space-between">
                    <div>
                      <div class="text-caption grey--text font-weight-medium mb-1">Con Diferencia</div>
                      <div class="text-h4 font-weight-bold orange--text text--darken-3">{{ diferencias.length }}</div>
                    </div>
                    <v-avatar color="orange lighten-5" size="44" class="rounded-xl">
                      <v-icon color="orange darken-3">mdi-alert-circle-outline</v-icon>
                    </v-avatar>
                  </div>
                </v-card>
              </v-col>
              <v-col cols="12" sm="4">
                <v-card outlined class="rounded-xl pa-4 kpi-confirm-card correct-kpi-confirm">
                  <div class="d-flex align-center justify-space-between">
                    <div>
                      <div class="text-caption grey--text font-weight-medium mb-1">Correctos</div>
                      <div class="text-h4 font-weight-bold green--text text--darken-3">{{ correctos.length }}</div>
                    </div>
                    <v-avatar color="green lighten-5" size="44" class="rounded-xl">
                      <v-icon color="green darken-3">mdi-check-circle-outline</v-icon>
                    </v-avatar>
                  </div>
                </v-card>
              </v-col>
            </v-row>

            <!-- Tabla de diferencias en confirmación -->
            <div v-if="diferencias.length > 0" class="mb-4">
              <div class="text-subtitle-2 font-weight-bold text-slate-700 mb-2">
                <v-icon size="18" color="orange darken-3" class="mr-1">mdi-alert-circle-outline</v-icon>
                Productos con diferencia que serán ajustados
              </div>
              <div class="table-wrapper rounded-xl border-light overflow-hidden">
                <v-simple-table dense class="modern-simple-table">
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left font-weight-bold text-slate-700 text-uppercase py-3">Producto</th>
                        <th class="text-center font-weight-bold text-slate-700 text-uppercase py-3" width="120">
                          Existencia</th>
                        <th class="text-center font-weight-bold text-slate-700 text-uppercase py-3" width="120">Contado
                        </th>
                        <th class="text-center font-weight-bold text-slate-700 text-uppercase py-3" width="120">Ajuste
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(dif, index) in diferencias" :key="index" class="table-row">
                        <td class="font-weight-medium text-slate-800 py-3">{{ dif.nm }}</td>
                        <td class="text-center py-3">
                          <span class="font-weight-semibold">{{ getExistencia(dif.id).Existencia }}</span>
                          <span class="text-caption grey--text ml-1">{{ getExistencia(dif.id).Unidad }}</span>
                        </td>
                        <td class="text-center font-weight-bold text-slate-800 py-3">{{ dif.cn }}</td>
                        <td class="text-center py-3">
                          <v-chip
                            :color="(dif.cn - getExistencia(dif.id).Existencia) > 0 ? 'green lighten-5' : 'red lighten-5'"
                            :text-color="(dif.cn - getExistencia(dif.id).Existencia) > 0 ? 'green darken-3' : 'red darken-3'"
                            small class="font-weight-bold px-2">
                            {{ (dif.cn - getExistencia(dif.id).Existencia) > 0 ? '+' : '' }}{{ dif.cn -
                              getExistencia(dif.id).Existencia }}
                          </v-chip>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </div>
            </div>

            <!-- Alerta sin diferencias -->
            <v-alert v-else outlined color="success" dense class="rounded-lg mb-4" icon="mdi-check-circle-outline">
              <span class="text-caption font-weight-medium">¡Excelente! No hay diferencias. El inventario físico
                coincide con el
                sistema.</span>
            </v-alert>

            <!-- Alerta ya aplicado -->
            <v-alert v-if="Estatus == 'A'" outlined color="info" dense class="rounded-lg mb-4"
              icon="mdi-information-outline">
              <span class="text-caption font-weight-medium">Este conteo ya fue aplicado al inventario.</span>
            </v-alert>
          </v-card>

          <!-- Acciones Paso 3 -->
          <div class="d-flex justify-space-between mt-4">
            <v-btn text class="font-weight-bold rounded-lg action-btn text-slate-700" @click="currentStep = 2">
              <v-icon left size="18">mdi-arrow-left</v-icon>
              Volver al Conteo
            </v-btn>

            <v-btn v-if="Estatus != 'A'" :loading="saving" @click="saveSend()" color="amber darken-3" dark depressed
              class="font-weight-bold rounded-lg action-btn apply-btn">
              <v-icon left size="18">mdi-clipboard-check-outline</v-icon>
              Aplicar a Inventario
            </v-btn>
          </div>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
  </div>
</template>



<script>
import addProductForm from "../TransferenciaMercancias/ProductExistForm.vue"
import { mapGetters } from "vuex";
export default {
  name: "Conteo",
  components: { addProductForm },
  props: [],
  data() {
    return {
      currentStep: 1,
      formExistKey: 1,
      OrnData: {},
      prodLoaded: 0,
      Estatus: null,
      saving: false,
      datailView: "1",
      filterProduct: "",
      Origen: "",
      Departamento: null,
      loading: false,
      Aplicado: false,
      title: "Nuevo Documento de conteo de inventarios",
      productsDocument: [],
    };
  },
  methods: {
    goRoute(routePath) {
      this.$router.push({ path: routePath });
    },
    goToStep2() {
      if (!this.Origen) {
        this.$swal(
          "Seleccione un almacén",
          "Por favor seleccione un centro de consumo para continuar.",
          "warning"
        );
        return;
      }
      this.currentStep = 2;
    },
    goToStep3() {
      this.currentStep = 3;
    },
    getNombreAlmacen(origen) {
      const found = this.origenes.find(o => o.id === origen);
      return found ? found.Nombre : origen;
    },
    saveExistProduct(datos) {
      let existProduct = this.$pgsHelper.getById(
        this.productsDocument,
        "id",
        datos.producto
      );
      if (existProduct) {
        this.productsDocument[existProduct.idx].cn += Number(datos.cantidad);
      } else {
        this.productsDocument.push({
          id: datos.producto,
          _e: true,
          cn: Number(datos.cantidad),
          nm: datos.nombre,
        });
      }
      this.$forceUpdate();
      this.tableKey++;
      this.showModalExist = false;
    },
    getExistencia(id) {
      let origenes = this.$store.getters.getOrigenes;
      let productosList = this.getProductos;
      let centroConsumo = this.$pgsHelper.getById(
        origenes,
        "Origen",
        this.Origen
      );

      let existencia = 0;
      let unidad = "";
      console.log("llego", this.Origen, origenes)
      if (centroConsumo) {
        console.log("llego 2")
        if (centroConsumo.Productos[id]) {
          let productOrigen = centroConsumo.Productos[id];
          console.log(productOrigen)
          existencia = productOrigen.Stock || null;
          let prod = this.$pgsHelper.getById(productosList, "id", id);
          unidad = prod?.Extra?.AYB?.UM || "PZA";
        }
      }
      return { Existencia: existencia, Unidad: unidad };
    },
    async getDocumentInfo(id) {
      this.productsDocument = [];
      let productosList = this.getProductos;
      this.loading = true;
      this.productos = [];
      const firestore = this.$store.getters.getFirebaseApp.firestore;
      const doc = firestore.doc("AMC_ConteosInventario/", id);
      const data = await firestore.getDoc(doc);

      let document = { id: data.ref.id, ...data.data() };
      let origenes = this.$store.getters.getOrigenes;
      this.Aplicado = document.Aplicado;
      if (!document.cto) {
        document.cto = {};
      }
      let productos = Object.entries(document.cto);
      this.OrnData = document;
      this.Origen = document.amc;
      this.Departamento = document.dpt;
      this.Estatus = document.sts;
      let centroConsumo = this.$pgsHelper.getById(
        origenes,
        "Origen",
        this.Origen
      );

      productos.forEach((element) => {
        let datos = element[1];
        let existencia = 0;
        let unidad = "";
        if (centroConsumo) {
          if (centroConsumo.Productos[element[0]]) {
            let productOrigen = centroConsumo.Productos[element[0]];
            existencia = productOrigen.Stock || null;
            let prod = this.$pgsHelper.getById(productosList, "id", element[0]);
            unidad = prod?.Extra?.AYB?.UM || "PZA";
          }
        }
        this.productsDocument.push({
          id: element[0],
          Cantidad: existencia,
          Unidad: unidad,
          ...datos,
        });
      });
      this.loading = false;
    },

    guardar(sendInv = false, goback = false) {
      if (this.Origen == "") {
        this.$swal(
          "Seleccione un centro de consumo",
          "Para continuar por favor indique el centro de consumo al que iran los productos",
          "error"
        );
        return false;
      }
      let data = {
        ...this.OrnData,
        amc: this.Origen,
        cto: {},
        sts: this.Estatus, //A|R
        dpt: this.Departamento,
      };
      this.productsDocument.forEach((element) => {
        element.cn = Number(element.cn);
        data.cto[element.id] = element;
      });


      this.createDocument(data, sendInv, goback);

    },
    saveSend() {
      this.guardar(true);
    },
    sendInventario(id) {
      this.saving = true;
      let datos = {
        Id: id,
        TipoMovimiento: "Conteo",
      };
      this.$store.getters.getFirebaseApp.fba
        .call("AMC-ConteosInventario-applyConteoInventario", datos)
        .then((result) => {
          if (result) {
            if (result.data.ok) {
              console.log(result)
              //this.getDocumentInfo(this.$route.params.idDocumento);
              this.saving = false;
              this.$swal({
                title: "Guardado",
                text: "El documento se envio a inventario correctamente",
                icon: "success",
              }).then(() => {
                this.restablecerComponente();
              });
            } else {
              this.saving = false;
              this.$swal("Error saving Documentos", result.data.error, "error");
            }
          }
        })
        .catch((error) => {
          this.$swal({
            title: "Error",
            text: `Request failed: ${error}`,
            icon: "error",
          });
          this.saving = false;
        });

    },
    deleteItem(id) {
      this.$swal({
        title: "¿Deseas eliminar este producto del documento?",
        text: "Los cambios se veran reflejados hasta realizar el guardado ",
        icon: "warning",
        showCancelButton: true,
        allowOutsideClick: false,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Eliminar",
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          this.productsDocument.forEach((element, index) => {
            if (element.id == id) {
              this.productsDocument.splice(index, 1);
            }
          });
          this.$swal({
            title: "Eliminado",
            text: "El producto se elimino corretamente",
            icon: "success",
          });
        }
      });
    },
    createDocument(datos, sendInv, goback) {
      this.saving = true;
      this.$pgsHelper.log(datos);
      //datos.Id = this.$route.params.idDocumento;
      this.$store.getters.getFirebaseApp.fba
        .call("AMC-ConteosInventario-createConteoInventario", datos)
        .then((result) => {
          if (result) {
            if (result.data.ok) {
              console.log(result)
              //this.getDocumentInfo(this.$route.params.idDocumento);
              this.saving = false;
              this.sendInventario(result.data.data.Id);
            } else {
              this.saving = false;
              this.$swal("Error saving Documentos", result.data.error, "error");
            }
          }
        })
        .catch((error) => {
          this.$swal({
            title: "Error",
            text: `Request failed: ${error}`,
            icon: "error",
          });
          this.saving = false;
        });
    },
    restablecerComponente() {
      this.currentStep = 1;
      this.formExistKey++;
      this.OrnData = {};
      this.prodLoaded = 0;
      this.Estatus = null;
      this.saving = false;
      this.filterProduct = "";
      this.Origen = "";
      this.Departamento = null;
      this.loading = false;
      this.Aplicado = false;
      this.title = "Nuevo Documento de conteo de inventarios";
      this.productsDocument = [];
    },
    init() {
      let productosList = this.getProductos;
      this.prodLoaded = productosList.length;

      if (this.$route.params.idDocumento) {
        this.title = "Edición de documento : " + this.$route.params.idDocumento;
        this.getDocumentInfo(this.$route.params.idDocumento);
      }
    },
  },
  computed: {
    ...mapGetters(["getProductos"]),
    modulos() {
      let dep = [
        /*{ value: "", text: "Seleccione un modulo" }*/
      ];
      let departamentos = this.$store.getters.getPDVDepartamentos;
      departamentos.forEach((element) => {
        dep.push({ value: element.id, text: element.Nombre });
      });
      return dep;
    },
    correctos() {
      let correctos = [];
      this.productsDocument.forEach((prod) => {
        if (this.getExistencia(prod.id).Existencia == prod.cn) {
          correctos.push(prod);
        }
      });
      return correctos;
    },
    diferencias() {
      let diferencias = [];
      this.productsDocument.forEach((prod) => {
        if (this.getExistencia(prod.id).Existencia != prod.cn) {
          diferencias.push(prod);
        }
      });
      return diferencias;
    },
    productosCount() {
      let producto = this.productsDocument;
      if (this.filterProduct !== "") {
        let filter = this.$_.map(producto, (o) => {
          if (o.nm.toUpperCase().includes(this.filterProduct.toUpperCase()))
            return o;
        });
        filter = this.$_.without(filter, undefined);
        return filter;
      }
      return producto;
    },
    origenes() {
      let ori = this.$store.getters.getCentrosConsumo;
      return ori;
    },
  },
  watch: {
    // Cuando se carga el documento y ya tiene Origen, avanzar directo al paso 2
    Origen(val) {
      if (val && this.currentStep === 1 && this.OrnData && this.OrnData.id) {
        this.currentStep = 2;
      }
    },
  },
  async mounted() {
    await this.init();
  },
  created() { },
};
</script>

<style scoped>
.menubtn {
  display: none;
}

.border-light {
  border: 1px solid #e2e8f0 !important;
}

.text-slate-800 {
  color: #1e293b !important;
}

.text-slate-700 {
  color: #334155 !important;
}

.text-slate-600 {
  color: #475569 !important;
}

.bg-slate-50 {
  background-color: #f8fafc !important;
}

.border-bottom {
  border-bottom: 1px solid #e2e8f0;
}

/* ── Stepper personalizado ── */
.stepper-custom {
  background-color: transparent !important;
  border: 1px solid #e2e8f0 !important;
  border-radius: 16px !important;
}

.stepper-header-custom {
  background-color: #f8fafc !important;
  border-bottom: 1px solid #e2e8f0;
  border-radius: 16px 16px 0 0 !important;
  padding: 8px 0;
}

.stepper-step-custom /deep/ .v-stepper__label {
  font-size: 0.72rem !important;
  font-weight: 600 !important;
  text-align: center;
  color: #64748b !important;
  line-height: 1.3;
}

.stepper-step-custom /deep/ .v-stepper__step__step {
  font-weight: 700 !important;
}

.stepper-divider {
  border-color: #cbd5e1 !important;
}

/* ── Step Card ── */
.step-card {
  background-color: #ffffff !important;
  border: 1px solid #e2e8f0 !important;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.04) !important;
}

.field-label {
  display: flex;
  align-items: center;
}

/* ── Summary info cards (paso 3) ── */
.summary-info-card {
  background-color: #f8fafc !important;
  border: 1px solid #e2e8f0 !important;
  transition: border-color 0.2s ease;
}

.kpi-confirm-card {
  background-color: #ffffff !important;
  border: 1px solid #e2e8f0 !important;
  transition: all 0.2s ease;
}

.apply-btn {
  padding: 0 24px !important;
  height: 44px !important;
}

/* ── Product picker ── */
.product-picker-card {
  background-color: #ffffff !important;
  border: 1px solid #e2e8f0 !important;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.02) !important;
}

.custom-input /deep/ .v-input__slot {
  background-color: #f8fafc !important;
  border: 1px solid #e2e8f0 !important;
  box-shadow: none !important;
  transition: all 0.2s ease;
}

.custom-input /deep/ .v-input__slot:focus-within {
  border-color: #3b82f6 !important;
  background-color: #ffffff !important;
}

.product-list-scroll::-webkit-scrollbar {
  width: 5px;
}

.product-list-scroll::-webkit-scrollbar-track {
  background: transparent;
}

.product-list-scroll::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 10px;
}

.product-list-scroll::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

.product-list-item {
  border: 1px solid #f1f5f9;
  transition: all 0.2s ease;
}

.product-list-item:hover {
  background-color: #f8fafc !important;
  border-color: #cbd5e1;
}

.spinner-container {
  width: 120px;
  height: 38px;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.spinner-input /deep/ input {
  text-align: center !important;
  font-weight: 700 !important;
  color: #1e293b !important;
  padding: 0 !important;
}

/* Remove chrome spinner controls */
.spinner-input /deep/ input::-webkit-outer-spin-button,
.spinner-input /deep/ input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.spinner-input /deep/ input[type=number] {
  -moz-appearance: textfield;
}

.action-btn {
  text-transform: none;
  letter-spacing: 0.2px;
  font-weight: 600;
  transition: all 0.2s ease;
}

.action-btn:hover {
  transform: translateY(-1px);
}

.table-container-card {
  background-color: #ffffff !important;
  border: 1px solid #e2e8f0 !important;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.02) !important;
}

.summary-kpi-card {
  border: 1px solid #e2e8f0;
  background-color: #ffffff !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.02) !important;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
}

.summary-kpi-card:hover {
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.05) !important;
  border-color: #cbd5e1;
}

.summary-kpi-card.active-kpi {
  transform: scale(1.02);
}

.summary-kpi-card.active-kpi.differences-kpi {
  border-color: #f97316 !important;
  background-color: #fffaf8 !important;
  box-shadow: 0 10px 15px -3px rgba(249, 115, 22, 0.1) !important;
}

.summary-kpi-card.active-kpi.correct-kpi {
  border-color: #22c55e !important;
  background-color: #f0fdf4 !important;
  box-shadow: 0 10px 15px -3px rgba(34, 197, 94, 0.1) !important;
}

.table-wrapper {
  border: 1px solid #e2e8f0;
  background-color: #ffffff;
}

.modern-simple-table {
  background-color: transparent !important;
}

.modern-simple-table /deep/ thead th {
  background-color: #f8fafc !important;
  border-bottom: 2px solid #e2e8f0 !important;
  color: #475569 !important;
  font-size: 0.75rem !important;
  letter-spacing: 0.5px;
}

.modern-simple-table /deep/ tbody tr.table-row {
  transition: background-color 0.2s ease;
}

.modern-simple-table /deep/ tbody tr.table-row:hover {
  background-color: #f8fafc !important;
}

.modern-simple-table /deep/ tbody tr:not(:last-child) td {
  border-bottom: 1px solid #f1f5f9 !important;
}

.cursor-pointer {
  cursor: pointer;
}

.gap-2 {
  gap: 8px;
}
</style>
